"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumber = exports.getCountryByCallingCode = exports.getCountryByCode = exports.DEFAULT_COUNTRY = exports.SUPPORTED_COUNTRIES = void 0;
exports.SUPPORTED_COUNTRIES = [
    {
        name: "Namibia",
        code: "NA",
        calling_code: "+264",
        flag: "🇳🇦",
    },
    {
        name: "South Africa",
        code: "ZA",
        calling_code: "+27",
        flag: "🇿🇦",
    },
    {
        name: "Botswana",
        code: "BW",
        calling_code: "+267",
        flag: "🇧🇼",
    },
    {
        name: "Zimbabwe",
        code: "ZW",
        calling_code: "+263",
        flag: "🇿🇼",
    },
    {
        name: "Zambia",
        code: "ZM",
        calling_code: "+260",
        flag: "🇿🇲",
    },
    {
        name: "Angola",
        code: "AO",
        calling_code: "+244",
        flag: "🇦🇴",
    },
    {
        name: "United States",
        code: "US",
        calling_code: "+1",
        flag: "🇺🇸",
    },
    {
        name: "United Kingdom",
        code: "GB",
        calling_code: "+44",
        flag: "🇬🇧",
    },
    {
        name: "Germany",
        code: "DE",
        calling_code: "+49",
        flag: "🇩🇪",
    },
    {
        name: "Australia",
        code: "AU",
        calling_code: "+61",
        flag: "🇦🇺",
    },
];
exports.DEFAULT_COUNTRY = exports.SUPPORTED_COUNTRIES.find(function (country) { return country.code === "NA"; }) ||
    exports.SUPPORTED_COUNTRIES[0];
var getCountryByCode = function (code) {
    return exports.SUPPORTED_COUNTRIES.find(function (country) { return country.code === code; });
};
exports.getCountryByCode = getCountryByCode;
var getCountryByCallingCode = function (callingCode) {
    return exports.SUPPORTED_COUNTRIES.find(function (country) { return country.calling_code === callingCode; });
};
exports.getCountryByCallingCode = getCountryByCallingCode;
var formatPhoneNumber = function (phoneNumber, country) {
    // Remove any non-digit characters
    var digits = phoneNumber.replace(/\D/g, "");
    // Format based on country
    switch (country.code) {
        case "NA": // Namibia: +264 XX XXX XXXX
            if (digits.length >= 9) {
                return "".concat(country.calling_code, " ").concat(digits.slice(0, 2), " ").concat(digits.slice(2, 5), " ").concat(digits.slice(5, 9));
            }
            break;
        case "ZA": // South Africa: +27 XX XXX XXXX
            if (digits.length >= 9) {
                return "".concat(country.calling_code, " ").concat(digits.slice(0, 2), " ").concat(digits.slice(2, 5), " ").concat(digits.slice(5, 9));
            }
            break;
        case "US": // USA: +1 (XXX) XXX-XXXX
            if (digits.length >= 10) {
                return "".concat(country.calling_code, " (").concat(digits.slice(0, 3), ") ").concat(digits.slice(3, 6), "-").concat(digits.slice(6, 10));
            }
            break;
        case "GB": // UK: +44 XXXX XXXXXX
            if (digits.length >= 10) {
                return "".concat(country.calling_code, " ").concat(digits.slice(0, 4), " ").concat(digits.slice(4));
            }
            break;
        default:
            // Generic format: +XXX XX XXX XXXX
            if (digits.length >= 8) {
                return "".concat(country.calling_code, " ").concat(digits.slice(0, 2), " ").concat(digits.slice(2, 5), " ").concat(digits.slice(5));
            }
            break;
    }
    return "".concat(country.calling_code, " ").concat(digits);
};
exports.formatPhoneNumber = formatPhoneNumber;
